import { useQuery } from '@tanstack/react-query';

import { chamarApi } from '../api/cliente.ts';

export type OrigemCadastrada = {
  codigo: string;
  nome: string;
  ativa: boolean;
  /** Reducee, Parceiro e Meta Ads: o sistema depende delas, então só se renomeiam. */
  travada: boolean;
  usos: number;
};

/**
 * As origens do cadastro (NEX-228), para toda tela que escolhe ou mostra uma.
 *
 * O Lead guarda o código, e `nome` o traduz para o que a Administradora
 * cadastrou — desativadas inclusive, porque o histórico continua com nome.
 * `ativas` é o que se oferece em registro novo.
 *
 * `pronta` existe pelo mesmo motivo que em `useOperadoras`: `<select>` não
 * controlado só lê o `defaultValue` na primeira pintura, e as opções chegam
 * depois. Quem usa passa `pronta` na `key` do campo.
 */
export function useOrigens(): {
  todas: OrigemCadastrada[];
  ativas: OrigemCadastrada[];
  nome: (codigo: string) => string;
  pronta: boolean;
} {
  const consulta = useQuery({
    queryKey: ['origens'],
    queryFn: () => chamarApi<OrigemCadastrada[]>('/origens'),
    staleTime: 60_000,
  });

  const todas = consulta.data ?? [];
  const nomes = new Map(todas.map((origem) => [origem.codigo, origem.nome]));
  return {
    todas,
    ativas: todas.filter((origem) => origem.ativa),
    // Enquanto a lista não chega, o código ainda diz alguma coisa; vazio não diria.
    nome: (codigo) => nomes.get(codigo) ?? codigo,
    pronta: consulta.isSuccess,
  };
}
